/**
 * Test IDs for QA automation.
 */
export const testIds = {
  receiverGoodsListModalCancel: "receiver-goods-list-modal-cancel",
  receiverGoodsListModalValidate: "receiver-goods-list-modal-validate",
} as const;
